var _defs, _g, _g2, _g3, _rect, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-400 -400 1130.648 755.38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7632",
    x: 170.457,
    y: 177.55,
    width: 1038.002,
    height: 775.716,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.62
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: -0.309,
    x2: 0.511,
    y2: 1.043,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.198,
    y1: 0.926,
    x2: 0.205,
    y2: 0.116,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3040",
    stopOpacity: 0.161
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7627",
    x: 170.017,
    y: 177.594,
    width: 1038.076,
    height: 186.582,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.38
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: -0.309,
    x2: 0.5,
    y2: 1.741,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62687",
    x: 233.669,
    y: 219.764,
    width: 62.243,
    height: 62.244,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1a284d",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.836,
    y1: -0.577,
    x2: 2.537,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9bb3cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9bb3cf",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62688",
    x: 270.892,
    y: 219.764,
    width: 62.244,
    height: 62.244,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1a284d",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62689",
    x: 308.116,
    y: 219.764,
    width: 62.244,
    height: 62.244,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1a284d",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Exclusion_23",
    x: 251.7,
    y: 587.376,
    width: 321.952,
    height: 321.953,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.481,
    y1: 0.401,
    x2: 0.577,
    y2: 1.812,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7636",
    x: 543.211,
    y: 701.623,
    width: 185.196,
    height: 185.196,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7637",
    x: 636.754,
    y: 701.623,
    width: 185.196,
    height: 185.196,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62697",
    x: 551.75,
    y: 715.437,
    width: 165.554,
    height: 160.096,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.62
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_49947",
    x: 956.324,
    y: 665.087,
    width: 121.199,
    height: 122.482,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_49948",
    x: 956.524,
    y: 565.146,
    width: 192.193,
    height: 222.366,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_49949",
    x: 956.516,
    y: 665.702,
    width: 211.931,
    height: 249.134,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_49950",
    x: 854.573,
    y: 593.76,
    width: 223.147,
    height: 265.527,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_49951",
    x: 885.323,
    y: 565.159,
    width: 192.191,
    height: 221.649,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_49952",
    x: 883.174,
    y: 665.819,
    width: 194.349,
    height: 224.234,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_49946",
    x: 956.301,
    y: 550.387,
    width: 284.697,
    height: 352.537,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2273",
    x: 130.103,
    y: 311.156,
    width: 492.911,
    height: 349.276,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.29
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.969,
    y1: 1.101,
    x2: 1.456,
    y2: 2.653,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2274",
    x: 115.353,
    y: 296.407,
    width: 492.911,
    height: 349.276,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2275",
    x: 100.778,
    y: 281.901,
    width: 492.911,
    height: 349.276,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1072",
    x: 64.027,
    y: 244.176,
    width: 269.184,
    height: 269.184,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-23"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.62
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-23"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.44,
    y1: 0.74,
    x2: 0.461,
    y2: 1.918,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Path_49942",
    x: 135.618,
    y: 279.478,
    width: 154.745,
    height: 162.29,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-24"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.62
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-24"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62686",
    x: 810.393,
    y: 221.007,
    width: 349.62,
    height: 350.987,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-25"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-25"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.538,
    y1: 0.863,
    x2: 0.335,
    y2: 2.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62687-2",
    x: 878.123,
    y: 314.744,
    width: 68.538,
    height: 68.539,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-26"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1a284d",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-26"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62688-2",
    x: 928.934,
    y: 314.744,
    width: 68.538,
    height: 68.539,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-27"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1a284d",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-27"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62689-2",
    x: 979.747,
    y: 314.744,
    width: 68.539,
    height: 68.539,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-28"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1a284d",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-28"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Component_81_1",
    "data-name": "Component 81 \\u2013 1",
    transform: "matrix(0.970592, 0.00588, 0, 1, -334.117554, -328.041443)",
    style: {}
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -131.656494, -242.176865)",
    filter: "url(#Rectangle_7632)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7632-2",
    "data-name": "Rectangle 7632",
    width: 918.002,
    height: 655.716,
    rx: 10,
    transform: "translate(205.46 212.55)",
    fill: "url(#linear-gradient-4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -131.656494, -242.176865)",
    filter: "url(#Rectangle_7627)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7627-2",
    "data-name": "Rectangle 7627",
    width: 918.076,
    height: 66.582,
    rx: 10,
    transform: "translate(205.02 212.59)",
    fill: "url(#linear-gradient-5)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29905",
    "data-name": "Group 29905",
    transform: "matrix(1, 0, 0, 1, 121.51252, -2.912854)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -253.17, -239.26)",
    filter: "url(#Path_62687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62687-3",
    "data-name": "Path 62687",
    d: "M3266.728,678.286a8.622,8.622,0,1,1-8.622-8.622,8.621,8.621,0,0,1,8.622,8.622",
    transform: "translate(-2996.32 -430.4)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -253.17, -239.26)",
    filter: "url(#Path_62688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62688-3",
    "data-name": "Path 62688",
    d: "M3431.475,678.286a8.622,8.622,0,1,1-8.622-8.622,8.622,8.622,0,0,1,8.622,8.622",
    transform: "translate(-3123.84 -430.4)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -253.17, -239.26)",
    filter: "url(#Path_62689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62689-3",
    "data-name": "Path 62689",
    d: "M3596.22,678.286a8.622,8.622,0,1,1-8.622-8.622,8.622,8.622,0,0,1,8.622,8.622",
    transform: "translate(-3251.36 -430.4)",
    fill: "url(#linear-gradient-6)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7631",
    "data-name": "Rectangle 7631",
    width: 916.342,
    height: 677.668,
    fill: "none",
    x: 74.36,
    y: -29.524
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -131.656494, -242.176865)",
    filter: "url(#Exclusion_23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_23-2",
    "data-name": "Exclusion 23",
    d: "M116.013,200.953H84.94l-5-15.112a18.1,18.1,0,0,0-25.3-10.481l-14.223,7.147L18.448,160.541l7.146-14.225a18.086,18.086,0,0,0-10.483-25.3L0,116.012V84.941l15.111-5a18.087,18.087,0,0,0,10.483-25.3L18.448,40.412,40.412,18.441l14.224,7.152a18.174,18.174,0,0,0,8.124,1.93A18.111,18.111,0,0,0,79.939,15.112L84.94,0h31.072l5,15.111A18.1,18.1,0,0,0,138.2,27.521a18.175,18.175,0,0,0,8.122-1.928l14.223-7.152,21.972,21.971-7.153,14.224a18.1,18.1,0,0,0,10.482,25.3l15.111,5v31.071l-15.111,5a18.1,18.1,0,0,0-10.482,25.3l7.153,14.224L160.54,182.507l-14.223-7.147a18.1,18.1,0,0,0-25.3,10.481l-5,15.111ZM100.185,54a46.189,46.189,0,1,0,46.19,46.189A46.241,46.241,0,0,0,100.185,54Z",
    transform: "translate(287.2 622.88)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.88,
    fill: "url(#linear-gradient-9)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -131.656494, -242.176865)",
    filter: "url(#Rectangle_7636)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7636-2",
    "data-name": "Rectangle 7636",
    width: 64.196,
    height: 64.196,
    rx: 10,
    transform: "translate(578.71 737.12)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.88,
    fill: "url(#linear-gradient-9)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -131.656494, -242.176865)",
    filter: "url(#Rectangle_7637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7637-2",
    "data-name": "Rectangle 7637",
    width: 64.196,
    height: 64.196,
    rx: 10,
    transform: "translate(672.25 737.12)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.88,
    fill: "url(#linear-gradient-9)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29904",
    "data-name": "Group 29904",
    transform: "matrix(1, 0, 0, 1, 456.087524, 190.080124)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    x2: 126.01,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    x2: 384.835,
    transform: "translate(0 91.748)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    x2: 384.835,
    transform: "translate(0 60.706)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x2: 384.835,
    transform: "translate(0 29.663)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    x2: 384.835,
    transform: "translate(0 122.791)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    x2: 298.036,
    transform: "translate(0 184.876)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x2: 342.186,
    transform: "translate(0 153.834)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62698",
    "data-name": "Path 62698",
    d: "M0,0H269",
    transform: "translate(0 215.918)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    x2: 240.823,
    transform: "translate(0 246.961)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -131.656494, -242.176865)",
    filter: "url(#Path_62697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62697-2",
    "data-name": "Path 62697",
    d: "M0,15.247,14.427,26.373,31.378,0",
    transform: "translate(595.77 755.91) rotate(8)",
    fill: "none",
    stroke: "#9bb3cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17302",
    "data-name": "Group 17302",
    transform: "matrix(1, 0, 0, 1, 758.416504, 343.914154)",
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17300",
    "data-name": "Group 17300",
    transform: "translate(101.947 14.555)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -992.02, -600.65)",
    filter: "url(#Path_49947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49947-2",
    "data-name": "Path 49947",
    d: "M457.264,230.1l0,0v-.007Z",
    transform: "translate(534.76 471.2)",
    fill: "#1f3040",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -992.02, -600.65)",
    filter: "url(#Path_49948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49948-2",
    "data-name": "Path 49948",
    d: "M457.266,192.208h0V292.857l70.983-71.844A101.586,101.586,0,0,0,457.266,192.208Z",
    transform: "translate(534.76 408.44)",
    fill: "#1f3040",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17301",
    "data-name": "Group 17301",
    transform: "translate(101.943 115.22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -992.02, -701.31)",
    filter: "url(#Path_49949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49949-2",
    "data-name": "Path 49949",
    d: "M457.29,230.106l-.027-.005V358.126h0a126.034,126.034,0,0,0,90.727-38.416Z",
    transform: "translate(534.75 471.21)",
    fill: "#1f3040",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -890.07, -586.09)",
    filter: "url(#Path_49950)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49950-2",
    "data-name": "Path 49950",
    d: "M449.851,203.056a101.863,101.863,0,0,0-2.165,144.113L520.829,274.9Z",
    transform: "translate(471.18 426.41)",
    fill: "#1d2e3e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -890.07, -586.09)",
    filter: "url(#Path_49951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49951-2",
    "data-name": "Path 49951",
    d: "M501.523,292.862V192.213a101.584,101.584,0,0,0-70.981,28.805l70.975,71.844Z",
    transform: "translate(490.49 408.45)",
    fill: "#9bb3cf",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -890.07, -586.09)",
    filter: "url(#Path_49952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49952-2",
    "data-name": "Path 49952",
    d: "M502.87,230.1l-73.138,72.261a101.618,101.618,0,0,0,73.146,30.973V230.1Z",
    transform: "translate(489.15 471.22)",
    fill: "rgba(155,179,207,0.28)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -890.07, -586.09)",
    filter: "url(#Path_49946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49946-2",
    "data-name": "Path 49946",
    d: "M574.565,417.852a163.361,163.361,0,0,0-3.475-231.123L457.26,301.949Z",
    transform: "translate(534.75 399.36)",
    fill: "#1f3040",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29907",
    "data-name": "Group 29907",
    transform: "matrix(1, 0, 0, 1, -32.629486, 36.999134)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -99.03, -279.18)",
    filter: "url(#Rectangle_2273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2273-2",
    "data-name": "Rectangle 2273",
    width: 371.911,
    height: 228.276,
    rx: 10,
    transform: "translate(165.6 346.66)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.88,
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -99.03, -279.18)",
    filter: "url(#Rectangle_2274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2274-2",
    "data-name": "Rectangle 2274",
    width: 371.911,
    height: 228.276,
    rx: 10,
    transform: "translate(150.85 331.91)",
    fill: "#07111a",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.78
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -99.03, -279.18)",
    filter: "url(#Rectangle_2275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2275-2",
    "data-name": "Rectangle 2275",
    width: 371.911,
    height: 228.276,
    rx: 10,
    transform: "translate(136.28 317.4)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.88,
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29906",
    "data-name": "Group 29906",
    transform: "translate(83.47 89.963)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    x2: 279.815,
    transform: "translate(0 31.042)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    x2: 279.815,
    transform: "translate(0)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    x2: 279.815,
    transform: "translate(0 62.085)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    x2: 279.815,
    transform: "translate(0 124.17)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    x2: 279.815,
    transform: "translate(0 93.127)",
    fill: "none",
    stroke: "#637196",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -99.03, -279.18)",
    filter: "url(#Ellipse_1072)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1072-2",
    "data-name": "Ellipse 1072",
    cx: 62.085,
    cy: 62.085,
    rx: 62.085,
    ry: 62.085,
    transform: "translate(99.03 400.08) rotate(-76.84)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -99.03, -279.18)",
    filter: "url(#Path_49942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49942-2",
    "data-name": "Path 49942",
    d: "M150.45,184.29v36.29h28.745",
    transform: "translate(23.17 133.19)",
    fill: "none",
    stroke: "#9bb3cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -131.656494, -242.176865)",
    filter: "url(#Path_62686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62686-2",
    "data-name": "Path 62686",
    d: "M3332.267,454.367H3161.711a29.032,29.032,0,0,0-29.032,29.031V607.85a29.033,29.033,0,0,0,29.032,29.032h11.552v31.8a15.47,15.47,0,0,0,24.98,12.2l56.452-44h77.572A29.032,29.032,0,0,0,3361.3,607.85V483.4a29.032,29.032,0,0,0-29.032-29.031",
    transform: "translate(-2286.79 -197.86)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient-15)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_29909",
    "data-name": "Group 29909",
    transform: "matrix(1, 0, 0, 1, 765.966492, 92.067123)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -897.62, -334.24)",
    filter: "url(#Path_62687-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62687-4",
    "data-name": "Path 62687",
    d: "M3273.023,681.433a11.769,11.769,0,1,1-11.769-11.769,11.769,11.769,0,0,1,11.769,11.769",
    transform: "translate(-2351.86 -335.42)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -897.62, -334.24)",
    filter: "url(#Path_62688-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62688-4",
    "data-name": "Path 62688",
    d: "M3437.769,681.433A11.769,11.769,0,1,1,3426,669.664a11.769,11.769,0,0,1,11.769,11.769",
    transform: "translate(-2465.8 -335.42)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -897.62, -334.24)",
    filter: "url(#Path_62689-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62689-4",
    "data-name": "Path 62689",
    d: "M3602.515,681.433a11.769,11.769,0,1,1-11.769-11.769,11.769,11.769,0,0,1,11.769,11.769",
    transform: "translate(-2579.73 -335.42)",
    fill: "url(#linear-gradient-6)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.ccc15e0d3e6c986d1b361fe679cfdff9.svg";
export { ForwardRef as ReactComponent };